const parseBooleanFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (!value) return fallback;
  const normalized = value.trim().toLowerCase();
  if (normalized === "true") return true;
  if (normalized === "false") return false;
  return fallback;
};

const configuredApiBaseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
const enableRemoteApiInDev = parseBooleanFlag(
  import.meta.env.VITE_ENABLE_REMOTE_API_IN_DEV as string | undefined,
  false,
);
const isRemoteApi = Boolean(
  configuredApiBaseUrl &&
    /^https?:\/\//i.test(configuredApiBaseUrl) &&
    !/^https?:\/\/(?:localhost|127\.0\.0\.1|\[::1\])(?::|\/|$)/i.test(configuredApiBaseUrl),
);
// Local development must not silently create real checkout sessions or CAPI
// events. A remote API is an explicit opt-in; localhost recorders remain usable.
const apiBaseUrl = import.meta.env.DEV && isRemoteApi && !enableRemoteApiInDev
  ? undefined
  : configuredApiBaseUrl;
const enableEmailCaptureFlag = import.meta.env.VITE_ENABLE_EMAIL_CAPTURE as string | undefined;
const configuredMetaPixelId = (import.meta.env.VITE_META_PIXEL_ID as string | undefined)?.trim();
const enableMetaInDev = parseBooleanFlag(import.meta.env.VITE_ENABLE_META_IN_DEV as string | undefined, false);
// Loading a real Pixel from localhost contaminates conversion reporting. Keep
// it disabled in dev unless the operator deliberately opts in (normally with a
// fake pixel id and VITE_META_SCRIPT_URL pointing at a local/data stub).
const metaPixelId = import.meta.env.DEV && !enableMetaInDev ? undefined : configuredMetaPixelId;
const metaScriptUrl = (import.meta.env.VITE_META_SCRIPT_URL as string | undefined)?.trim();
const loadMetaScript = parseBooleanFlag(import.meta.env.VITE_LOAD_META_SCRIPT as string | undefined, true);
const metaQaDebug = parseBooleanFlag(import.meta.env.VITE_META_QA_DEBUG as string | undefined, false);
const configuredPosthogKey = (import.meta.env.VITE_POSTHOG_KEY as string | undefined)?.trim();
const enablePosthogInDev = parseBooleanFlag(import.meta.env.VITE_ENABLE_POSTHOG_IN_DEV as string | undefined, false);
const posthogKey = import.meta.env.DEV && !enablePosthogInDev ? undefined : configuredPosthogKey;
const posthogQaDebug = parseBooleanFlag(import.meta.env.VITE_POSTHOG_QA_DEBUG as string | undefined, false);
const metaDedupDebugFlag = import.meta.env.VITE_META_DEDUP_DEBUG as string | undefined;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;
const polarTrialDays = import.meta.env.VITE_POLAR_TRIAL_DAYS as string | undefined;
const polarTrialRenewalCopy = import.meta.env.VITE_POLAR_TRIAL_RENEWAL_COPY as string | undefined;

export const config = {
  apiBaseUrl: apiBaseUrl?.replace(/\/$/, "") ?? "",
  enableEmailCapture: parseBooleanFlag(enableEmailCaptureFlag, true),
  metaPixelId: metaPixelId?.trim() ?? "",
  metaScriptUrl: metaScriptUrl || "https://connect.facebook.net/en_US/fbevents.js",
  loadMetaScript,
  metaQaDebug,
  metaDedupDebug: parseBooleanFlag(metaDedupDebugFlag, false),
  posthogKey: posthogKey?.trim() ?? "",
  posthogHost: posthogHost?.trim() || "https://us.i.posthog.com",
  posthogQaDebug,
  polarTrialDays: polarTrialDays?.trim() || "7",
  polarTrialRenewalCopy: polarTrialRenewalCopy?.trim() || "Then renews annually unless canceled.",
} as const;

export const brand = {
  name: "AgentMax",
  navbarIconPath: "/assets/brand/navbar-icon-light-bg.webp",
  heroGraphicPath: "/assets/product/hero.webp",
  menubarPreviewPath: "/assets/product/product-ui-menubar.webp",
  privacyPolicyUrl: "https://agentmax.dev/privacy",
  termsUrl: "https://agentmax.dev/terms",
  macosMinimumVersion: "macOS 14+",
} as const;
